<template>
  <div
    class="report-row"
    :class="{ 'report-row--clickable': clickable }"
    :role="clickable ? 'button' : null"
    :tabindex="clickable ? 0 : null"
    @click="onClick"
    @keydown.enter="onClick"
  >
    <div v-if="$slots.leading" class="report-row__leading">
      <slot name="leading" />
    </div>

    <div class="report-row__body">
      <div class="report-row__title">
        <slot name="title" />
      </div>
      <div v-if="$slots.subtitle" class="report-row__subtitle">
        <slot name="subtitle" />
      </div>
    </div>

    <div v-if="$slots.trailing" class="report-row__trailing">
      <slot name="trailing" />
    </div>

    <v-icon v-if="clickable" class="report-row__chevron" size="22">mdi-chevron-right</v-icon>
  </div>
</template>

<script>
export default {
  name: 'ReportListRow',
  props: {
    clickable: { type: Boolean, default: false }
  },
  methods: {
    onClick(event) {
      if (this.clickable) this.$emit('click', event);
    }
  }
};
</script>

<style lang="scss" scoped>
.report-row {
  align-items: center;
  border-bottom: 1px solid var(--app-border);
  display: flex;
  gap: 12px;
  min-width: 0;
  padding: 12px 14px;
  width: 100%;
}

.report-row--clickable {
  cursor: pointer;
}

.report-row--clickable:active {
  background: #f8fafc;
}

.report-row__leading {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
}

.report-row__body {
  flex: 1;
  min-width: 0;
}

.report-row__title {
  color: var(--app-text);
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-row__subtitle {
  color: var(--app-text-muted);
  font-size: 12px;
  margin-top: 2px;
}

.report-row__trailing {
  align-items: flex-end;
  color: var(--app-text);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  font-size: 15px;
  font-weight: 700;
  gap: 2px;
  text-align: right;
}

.report-row__chevron {
  color: var(--app-text-muted) !important;
  flex-shrink: 0;
}
</style>
